export const getCourse = (id) => ({
  method: "GET",
  route: `${window.ENV?.API_URL}courses/${id}`,
});
